import { jsxs as D, jsx as o } from "react/jsx-runtime";
import * as y from "react";
import { forwardRef as S, useState as $ } from "react";
import { I as M } from "./ic_add-Vjwi0Osr.mjs";
import { c as z } from "./index.js-Cr0Rsuyz.mjs";
import { c as B } from "./index-BpNK5r1N.mjs";
import { T as R } from "./text-field-CWfvoDTt.mjs";
import { c as A } from "./tw-cn-mXgPecoF.mjs";
function F(d, m) {
  return /* @__PURE__ */ y.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: m
  }, d), /* @__PURE__ */ y.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12.001a.75.75 0 0 1-.75.75H4.75a.75.75 0 0 1 0-1.5h14.5a.75.75 0 0 1 .75.75",
    clipRule: "evenodd"
  }));
}
var H = z(/* @__PURE__ */ S(F));
const O = B("flex w-fit shrink-0 items-center"), I = B(
  [
    "flex min-h-36 min-w-34 shrink-0 items-center justify-center border  border-line-neutral-weak3 p-4",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "disabled:bg-fill-neutral-weak [&>*]:disabled:!text-interaction-neutral-disable-main",
    "disabled:hover-never:bg-fill-neutral-weak "
  ],
  {
    variants: {
      type: {
        minus: "border-r-0 rounded-l-8",
        plus: "border-l-0 rounded-r-8"
      }
    }
  }
), P = S((d, m) => {
  const {
    id: w,
    defaultValue: V = "",
    value: N,
    min: r = 0,
    max: i = 999,
    disabled: l = !1,
    className: g,
    onChange: t,
    onInvalidRange: s
  } = d, p = w ? `${w}-` : "", [j, u] = $(`${V}`), [C, b] = $(!1), n = N !== void 0, c = n ? `${N}` : j, f = Number(c) <= r || l, v = Number(c) >= i || l, h = (e) => {
    if (e === "")
      return !1;
    const a = Number(e);
    return Number.isInteger(a);
  }, x = (e) => {
    e < r ? (s == null || s(e), n ? t == null || t(r) : u(`${r}`)) : e > i ? (s == null || s(e), n ? t == null || t(i) : u(`${i}`)) : n ? t == null || t(e) : u(`${e}`);
  }, k = (e) => {
    const a = Number(c || r) + e;
    x(a);
  }, E = (e) => {
    const a = e.target.value;
    if (b(!1), a === "") {
      s == null || s(""), b(!0), n ? t == null || t(r) : u(`${r}`);
      return;
    }
    h(a) && x(Number(a));
  }, T = (e) => {
    const a = e.target.value;
    h(a) || (b(!1), x(r));
  };
  return /* @__PURE__ */ D("div", { className: A(O(), g), children: [
    /* @__PURE__ */ o(
      "button",
      {
        "aria-disabled": f || void 0,
        "aria-label": "마이너스 버튼",
        className: I({ type: "minus" }),
        disabled: f,
        id: `${p}stepper-minus`,
        onClick: () => {
          k(-1);
        },
        tabIndex: f ? -1 : 0,
        type: "button",
        children: /* @__PURE__ */ o(H, { className: "size-16 text-text-neutral-main" })
      }
    ),
    /* @__PURE__ */ o(
      R,
      {
        "aria-disabled": l || void 0,
        "aria-label": "숫자 입력",
        className: "w-fit",
        disabled: l,
        id: `${p}stepper-input`,
        inputClassName: "text-center !font-bold",
        inputMode: "numeric",
        inputWrapperClassName: "!p-4 rounded-none min-h-36 pc:min-h-36 w-40 pc:w-40 !border-[1px]",
        max: i,
        min: r,
        onBlur: T,
        onChange: E,
        ref: m,
        tabIndex: l ? -1 : 0,
        type: "number",
        value: C ? "" : c
      }
    ),
    /* @__PURE__ */ o(
      "button",
      {
        "aria-disabled": v || void 0,
        "aria-label": "플러스 버튼",
        className: I({ type: "plus" }),
        disabled: v,
        id: `${p}stepper-plus`,
        onClick: () => {
          k(1);
        },
        tabIndex: v ? -1 : 0,
        type: "button",
        children: /* @__PURE__ */ o(M, { className: "size-16 text-text-neutral-main" })
      }
    )
  ] });
});
P.displayName = "NDS.Stepper";
export {
  P as S
};
